import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals, alert } from 'src/theme/colors';

export const styles = StyleSheet.create({
  alertToastContainer: {
    display: 'flex',
    backgroundColor: neutrals.white,
    flexDirection: 'row',
    justifyContent: 'space-between',
    minWidth: 252,
    padding: 16,
    borderRadius: 16,
    gap: 16,
    maxWidth: 450,
    ...getBoxShadow({
      offsetX: 0,
      offsetY: 2,
      blurRadius: 12,
      spreadRadius: 0,
      color: neutrals.black,
      opacity: 0.15,
    }),
  },
  alertToastContainerMobile: {
    minWidth: '90%',
    right: 16,
    left: 16,
  },
  ctaContainer: {
    marginLeft: 8,
    gap: 8,
    display: 'flex',
    flexDirection: 'row',
    borderWidth: 2,
    borderColor: 'transparent',
    alignItems: 'center',
    minHeight: 0,
    backgroundColor: neutrals.white,
    ...getBoxShadow('none'),
  },
  ctaContainerFocus: {
    borderColor: FOCUS_COLOR,
  },
  ctaInnerContainer: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  ctaClose: {
    gap: 8,
    display: 'flex',
    flexDirection: 'row',
    borderWidth: 2,
    borderColor: 'transparent',
    alignItems: 'center',
    minHeight: 0,
    backgroundColor: neutrals.white,
    ...getBoxShadow('none'),
  },
  alertText: { color: neutrals.neutralGrays.coal, fontSize: 16, flexGrow: 2 },
  alertTextMobile: { fontSize: 14 },
  ctaText: {
    color: brand.main.water,
    fontSize: 14,
    fontWeight: 700,
  },
  ctaTextError: {
    color: alert.alertRed,
  },
  ctaTextMobile: { color: brand.main.variations['lighterWater-2'] },
  icon: {
    width: 14,
    height: 14,
    color: brand.main.water,
  },
  iconToast: {
    width: 20,
    height: 20,
  },
});
